// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base Styles */
.internship-reg-container {
  font-family: 'Comic Neue', 'Nunito', sans-serif;
  color: #2d3748;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Registration Header */
.registration-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #ebf8ff 0%, #f0fff4 100%);
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
}

.registration-header h1 {
  font-size: 2.5rem;
  color: #2b6cb0;
  margin-bottom: 15px;
}

.registration-header h1 span {
  color: #2c5282;
}

.registration-header p {
  font-size: 1.2rem;
  color: #4a5568;
}

/* Registration Form */
.registration-form-container {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  margin-bottom: 40px;
  border: 1px solid #e2e8f0;
}

.registration-form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-row .form-group {
  flex: 1 1;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2b6cb0;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: #4299e1;
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

/* File Upload Styles */
.file-upload {
  position: relative;
}

.file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.file-info {
  padding: 12px 15px;
  border: 2px dashed #e2e8f0;
  border-radius: 10px;
  text-align: center;
  background-color: #f8fafc;
  color: #4a5568;
}

.file-info:hover {
  border-color: #4299e1;
}

/* React Select Customization */
.react-select-container .react-select__control {
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  min-height: 48px;
  transition: all 0.3s;
}

.react-select-container .react-select__control--is-focused {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
}

.react-select-container .react-select__option--is-selected {
  background-color: #2b6cb0;
}

.react-select-container .react-select__option--is-focused {
  background-color: #ebf8ff;
}

/* Submit Button */
.submit-button {
  background-color: #2b6cb0;
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 8px rgba(43, 108, 176, 0.3);
  width: auto; /* Changed from 100% to auto */
  min-width: 250px; /* Added minimum width */
  margin-top: 20px;
}

.submit-button:hover {
  background-color: #2c5282;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(43, 108, 176, 0.4);
}
.form-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.form-note {
  text-align: center;
  margin-top: 15px;
  font-size: 0.9rem;
  color: #718096;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 15px;
  }

  .registration-header h1 {
    font-size: 2rem;
  }

  .registration-form-container {
    padding: 25px;
  }
}
/* React Select Customization to match other fields */
.react-select-container {
  width: 100%;
  
}

.react-select__control {
  background-color: #f8fafc !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  min-height: 48px !important;
  transition: all 0.3s !important;
  padding: 2px 0 !important;
  box-shadow: none !important;
}

.react-select__control--is-focused {
  border-color: #4299e1 !important;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2) !important;
}

.react-select__value-container {
  padding: 0 15px !important;
}

.react-select__placeholder, 
.react-select__single-value {
  color: #4a5568 !important;
  font-size: 1rem !important;
}

.react-select__indicator {
  padding: 8px 15px !important;
  color: #4a5568 !important;
}

.react-select__menu {
  border-radius: 10px !important;
  border: 2px solid #e2e8f0 !important;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
}

.react-select__option {
  padding: 12px 15px !important;
}

.react-select__option--is-focused {
  background-color: #ebf8ff !important;
  color: #2b6cb0 !important;
}

.react-select__option--is-selected {
  background-color: #2b6cb0 !important;
  color: white !important;
}

/* Add these styles to your existing Internship_Reg.css */

/* Form Sections */
.form-section {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e2e8f0;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 20px;
}

.form-section h2 {
  color: #2b6cb0;
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.form-section p {
  color: #4a5568;
  margin-bottom: 20px;
}

/* Radio Group Styles */
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #f8fafc;
  transition: all 0.2s;
}

.radio-option:hover {
  background-color: #ebf8ff;
}

.radio-option input {
  margin-right: 10px;
  cursor: pointer;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .radio-group {
    gap: 8px;
  }
  
  .radio-option {
    padding: 8px 12px;
  }
}

/* Base Styles - keep existing styles, add these new ones */

/* Knowledge Assessment Section */
.knowledge-assessment {
  background-color: #f8fafc;
  padding: 30px;
  border-radius: 12px;
  margin-top: 30px;
}

.section-description {
  color: #4a5568;
  margin-bottom: 25px;
  font-size: 1rem;
}

.assessment-question {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e2e8f0;
}

.assessment-question:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.assessment-question label {
  display: block;
  margin-bottom: 12px;
  font-weight: 600;
  color: #2d3748;
  font-size: 1rem;
}

/* Radio Options Grid */
.radio-options-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.radio-option {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  gap: 100px; 
}

.radio-option:hover {
  border-color: #4299e1;
  box-shadow: 0 2px 6px rgba(66, 153, 225, 0.1);
}

/* .radio-option input[type="radio"] {
  margin-right: 10px;
  width: 16px;
  height: 16px;
  accent-color: #2b6cb0;
   flex-shrink: 0;
} */

.radio-input-container {
  display: flex;
  align-items: center;
  height: 100%;
}
.radio-option input[type="radio"] {
  /* margin: 0;  */
  width: 16px;
  height: 14px;
  accent-color: #2b6cb0;
  position: relative;
  top: 0; /* Remove any default positioning */
  gap: 90px;
  margin: 0 12px 0 0; /* Right margin creates space between radio and text */
}

.radio-option label {
  margin: 0;
  font-weight: 500;
  cursor: pointer;
  line-height: 1.5; /* Match the radio button height */
  gap: 100px;
  margin-left: 200px;
  flex-grow: 1;
}

/* .radio-option label {
  margin-bottom: 0;
  font-weight: 500;
  cursor: pointer;
 
} */

/* File Upload Improvements */
.file-upload {
  border: 2px dashed #e2e8f0;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s;
}

.file-upload:hover {
  border-color: #4299e1;
  background-color: #f0f9ff;
}

.file-upload label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #2b6cb0;
}

.file-info {
  font-size: 0.9rem;
  color: #4a5568;
  margin-top: 10px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .knowledge-assessment {
    padding: 20px;
  }
  
  .radio-options-grid {
    grid-template-columns: 1fr;
  }
  
  .form-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .file-upload {
    padding: 15px;
  }
}

/* Enhanced Select Styles */
/* .react-select-container {
  width: 100%;
  margin-top: 8px;
}

.react-select__control {
  min-height: 48px !important;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
}

.react-select__control--is-focused {
  border-color: #4299e1 !important;
  box-shadow: 0 0 0 1px #4299e1 !important;
}

.react-select__option--is-focused {
  background-color: #ebf8ff !important;
}

.react-select__option--is-selected {
  background-color: #2b6cb0 !important;
} */

/* React Select Customization to match other fields */
.react-select-container {
  width: 100%;
}

.react-select__control {
  background-color: #f8fafc !important;  /* Added gray background */
  border: 2px solid #e2e8f0 !important;
  border-radius: 10px !important;
  min-height: 48px !important;
  transition: all 0.3s !important;
  padding: 2px 0 !important;
  box-shadow: none !important;
}

.react-select__control--is-focused {
  background-color: white !important;  /* White when focused */
  border-color: #4299e1 !important;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2) !important;
}

.react-select__value-container {
  padding: 0 15px !important;
  background-color: transparent !important;  /* Ensure container is transparent */
}

.react-select__placeholder, 
.react-select__single-value {
  color: #4a5568 !important;
  font-size: 1rem !important;
}

.react-select__indicator {
  padding: 8px 15px !important;
  color: #4a5568 !important;
}

.react-select__menu {
  border-radius: 10px !important;
  border: 2px solid #e2e8f0 !important;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
  background-color: white !important;  /* White dropdown */
}

.react-select__option {
  padding: 12px 15px !important;
  background-color: white !important;  /* White options */
}

.react-select__option--is-focused {
  background-color: #ebf8ff !important;
  color: #2b6cb0 !important;
}

.react-select__option--is-selected {
  background-color: #2b6cb0 !important;
  color: white !important;
}

/* Form Section Spacing */
.form-section {
  margin-bottom: 40px;
}

.form-section h2 {
  color: #2b6cb0;
  margin-bottom: 20px;
  font-size: 1.5rem;
  position: relative;
  padding-bottom: 10px;
}

.form-section h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: #4299e1;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/Internship/Internship_Reg.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,+CAA+C;EAC/C,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,6CAA6C;EAC7C,WAAW,EAAE,8BAA8B;EAC3C,gBAAgB,EAAE,wBAAwB;EAC1C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;AACA,qDAAqD;AACrD;EACE,WAAW;;AAEb;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,yDAAyD;;AAEzD,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2DAA2D;;AAE3D,iCAAiC;AACjC;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,MAAM,EAAE,mCAAmC;EAC3C,SAAS;EACT,kBAAkB,EAAE,sDAAsD;AAC5E;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE,kCAAkC;EACpD,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;;;GAKG;;AAEH,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH,qDAAqD;AACrD;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC,GAAG,0BAA0B;EACjE,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC,GAAG,uBAAuB;EAC5D,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC,GAAG,oCAAoC;AACjF;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,iDAAiD;EACjD,kCAAkC,GAAG,mBAAmB;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC,GAAG,kBAAkB;AACzD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/* Base Styles */\n.internship-reg-container {\n  font-family: 'Comic Neue', 'Nunito', sans-serif;\n  color: #2d3748;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Registration Header */\n.registration-header {\n  text-align: center;\n  margin-bottom: 40px;\n  padding: 30px;\n  background: linear-gradient(135deg, #ebf8ff 0%, #f0fff4 100%);\n  border-radius: 20px;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.05);\n}\n\n.registration-header h1 {\n  font-size: 2.5rem;\n  color: #2b6cb0;\n  margin-bottom: 15px;\n}\n\n.registration-header h1 span {\n  color: #2c5282;\n}\n\n.registration-header p {\n  font-size: 1.2rem;\n  color: #4a5568;\n}\n\n/* Registration Form */\n.registration-form-container {\n  background: white;\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n  margin-bottom: 40px;\n  border: 1px solid #e2e8f0;\n}\n\n.registration-form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.form-row {\n  display: flex;\n  gap: 20px;\n}\n\n.form-row .form-group {\n  flex: 1;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #2b6cb0;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: #4299e1;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);\n}\n\n.form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n/* File Upload Styles */\n.file-upload {\n  position: relative;\n}\n\n.file-upload input[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.file-info {\n  padding: 12px 15px;\n  border: 2px dashed #e2e8f0;\n  border-radius: 10px;\n  text-align: center;\n  background-color: #f8fafc;\n  color: #4a5568;\n}\n\n.file-info:hover {\n  border-color: #4299e1;\n}\n\n/* React Select Customization */\n.react-select-container .react-select__control {\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  min-height: 48px;\n  transition: all 0.3s;\n}\n\n.react-select-container .react-select__control--is-focused {\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);\n}\n\n.react-select-container .react-select__option--is-selected {\n  background-color: #2b6cb0;\n}\n\n.react-select-container .react-select__option--is-focused {\n  background-color: #ebf8ff;\n}\n\n/* Submit Button */\n.submit-button {\n  background-color: #2b6cb0;\n  color: white;\n  border: none;\n  padding: 15px 30px;\n  border-radius: 30px;\n  font-size: 1.1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 4px 8px rgba(43, 108, 176, 0.3);\n  width: auto; /* Changed from 100% to auto */\n  min-width: 250px; /* Added minimum width */\n  margin-top: 20px;\n}\n\n.submit-button:hover {\n  background-color: #2c5282;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(43, 108, 176, 0.4);\n}\n.form-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.form-note {\n  text-align: center;\n  margin-top: 15px;\n  font-size: 0.9rem;\n  color: #718096;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .registration-header h1 {\n    font-size: 2rem;\n  }\n\n  .registration-form-container {\n    padding: 25px;\n  }\n}\n/* React Select Customization to match other fields */\n.react-select-container {\n  width: 100%;\n  \n}\n\n.react-select__control {\n  background-color: #f8fafc !important;\n  border: 2px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  min-height: 48px !important;\n  transition: all 0.3s !important;\n  padding: 2px 0 !important;\n  box-shadow: none !important;\n}\n\n.react-select__control--is-focused {\n  border-color: #4299e1 !important;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2) !important;\n}\n\n.react-select__value-container {\n  padding: 0 15px !important;\n}\n\n.react-select__placeholder, \n.react-select__single-value {\n  color: #4a5568 !important;\n  font-size: 1rem !important;\n}\n\n.react-select__indicator {\n  padding: 8px 15px !important;\n  color: #4a5568 !important;\n}\n\n.react-select__menu {\n  border-radius: 10px !important;\n  border: 2px solid #e2e8f0 !important;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;\n}\n\n.react-select__option {\n  padding: 12px 15px !important;\n}\n\n.react-select__option--is-focused {\n  background-color: #ebf8ff !important;\n  color: #2b6cb0 !important;\n}\n\n.react-select__option--is-selected {\n  background-color: #2b6cb0 !important;\n  color: white !important;\n}\n\n/* Add these styles to your existing Internship_Reg.css */\n\n/* Form Sections */\n.form-section {\n  margin-bottom: 40px;\n  padding-bottom: 30px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.form-section:last-child {\n  border-bottom: none;\n  margin-bottom: 20px;\n}\n\n.form-section h2 {\n  color: #2b6cb0;\n  margin-bottom: 15px;\n  font-size: 1.5rem;\n}\n\n.form-section p {\n  color: #4a5568;\n  margin-bottom: 20px;\n}\n\n/* Radio Group Styles */\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px 15px;\n  border-radius: 8px;\n  background-color: #f8fafc;\n  transition: all 0.2s;\n}\n\n.radio-option:hover {\n  background-color: #ebf8ff;\n}\n\n.radio-option input {\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .radio-group {\n    gap: 8px;\n  }\n  \n  .radio-option {\n    padding: 8px 12px;\n  }\n}\n\n/* Base Styles - keep existing styles, add these new ones */\n\n/* Knowledge Assessment Section */\n.knowledge-assessment {\n  background-color: #f8fafc;\n  padding: 30px;\n  border-radius: 12px;\n  margin-top: 30px;\n}\n\n.section-description {\n  color: #4a5568;\n  margin-bottom: 25px;\n  font-size: 1rem;\n}\n\n.assessment-question {\n  margin-bottom: 25px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.assessment-question:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.assessment-question label {\n  display: block;\n  margin-bottom: 12px;\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1rem;\n}\n\n/* Radio Options Grid */\n.radio-options-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n  gap: 100px; \n}\n\n.radio-option:hover {\n  border-color: #4299e1;\n  box-shadow: 0 2px 6px rgba(66, 153, 225, 0.1);\n}\n\n/* .radio-option input[type=\"radio\"] {\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n  accent-color: #2b6cb0;\n   flex-shrink: 0;\n} */\n\n.radio-input-container {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.radio-option input[type=\"radio\"] {\n  /* margin: 0;  */\n  width: 16px;\n  height: 14px;\n  accent-color: #2b6cb0;\n  position: relative;\n  top: 0; /* Remove any default positioning */\n  gap: 90px;\n  margin: 0 12px 0 0; /* Right margin creates space between radio and text */\n}\n\n.radio-option label {\n  margin: 0;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 1.5; /* Match the radio button height */\n  gap: 100px;\n  margin-left: 200px;\n  flex-grow: 1;\n}\n\n/* .radio-option label {\n  margin-bottom: 0;\n  font-weight: 500;\n  cursor: pointer;\n \n} */\n\n/* File Upload Improvements */\n.file-upload {\n  border: 2px dashed #e2e8f0;\n  border-radius: 10px;\n  padding: 20px;\n  text-align: center;\n  transition: all 0.3s;\n}\n\n.file-upload:hover {\n  border-color: #4299e1;\n  background-color: #f0f9ff;\n}\n\n.file-upload label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 600;\n  color: #2b6cb0;\n}\n\n.file-info {\n  font-size: 0.9rem;\n  color: #4a5568;\n  margin-top: 10px;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .knowledge-assessment {\n    padding: 20px;\n  }\n  \n  .radio-options-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .file-upload {\n    padding: 15px;\n  }\n}\n\n/* Enhanced Select Styles */\n/* .react-select-container {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.react-select__control {\n  min-height: 48px !important;\n  border-radius: 8px !important;\n  border: 1px solid #e2e8f0 !important;\n  box-shadow: none !important;\n}\n\n.react-select__control--is-focused {\n  border-color: #4299e1 !important;\n  box-shadow: 0 0 0 1px #4299e1 !important;\n}\n\n.react-select__option--is-focused {\n  background-color: #ebf8ff !important;\n}\n\n.react-select__option--is-selected {\n  background-color: #2b6cb0 !important;\n} */\n\n/* React Select Customization to match other fields */\n.react-select-container {\n  width: 100%;\n}\n\n.react-select__control {\n  background-color: #f8fafc !important;  /* Added gray background */\n  border: 2px solid #e2e8f0 !important;\n  border-radius: 10px !important;\n  min-height: 48px !important;\n  transition: all 0.3s !important;\n  padding: 2px 0 !important;\n  box-shadow: none !important;\n}\n\n.react-select__control--is-focused {\n  background-color: white !important;  /* White when focused */\n  border-color: #4299e1 !important;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2) !important;\n}\n\n.react-select__value-container {\n  padding: 0 15px !important;\n  background-color: transparent !important;  /* Ensure container is transparent */\n}\n\n.react-select__placeholder, \n.react-select__single-value {\n  color: #4a5568 !important;\n  font-size: 1rem !important;\n}\n\n.react-select__indicator {\n  padding: 8px 15px !important;\n  color: #4a5568 !important;\n}\n\n.react-select__menu {\n  border-radius: 10px !important;\n  border: 2px solid #e2e8f0 !important;\n  box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;\n  background-color: white !important;  /* White dropdown */\n}\n\n.react-select__option {\n  padding: 12px 15px !important;\n  background-color: white !important;  /* White options */\n}\n\n.react-select__option--is-focused {\n  background-color: #ebf8ff !important;\n  color: #2b6cb0 !important;\n}\n\n.react-select__option--is-selected {\n  background-color: #2b6cb0 !important;\n  color: white !important;\n}\n\n/* Form Section Spacing */\n.form-section {\n  margin-bottom: 40px;\n}\n\n.form-section h2 {\n  color: #2b6cb0;\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  position: relative;\n  padding-bottom: 10px;\n}\n\n.form-section h2::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 60px;\n  height: 3px;\n  background-color: #4299e1;\n  border-radius: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
